'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n    height: 100%;\n'], ['\n    width: 100%;\n    height: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  ', '\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    height: 50px;\n    cursor: pointer;\n    color: ', ';\n    border: 1px solid #EEEEEE;\n    background-color: white;\n    ', '\n    ', '\n'], ['\n    height: 50px;\n    cursor: pointer;\n    color: ', ';\n    border: 1px solid #EEEEEE;\n    background-color: white;\n    ', '\n    ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    border-radius: 3px;\n    background: ', ';\n    width: 5px;\n    height: 50px;\n    margin-left: 5px;\n'], ['\n    display: flex;\n    border-radius: 3px;\n    background: ', ';\n    width: 5px;\n    height: 50px;\n    margin-left: 5px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../constants/colors');

var _sizes = require('../../constants/sizes');

var _opacity = require('../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _alignments = require('../../constants/alignments');

var _getColor = require('../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SideTabWrapper = _styledComponents2.default.div(_templateObject);

var SideTabInner = _styledComponents2.default.div(_templateObject2, function (_ref) {
    var desktop = _ref.desktop;
    return desktop && '\n        flex-direction: column;\n    ';
});

var MenuTab = (0, _styledComponents2.default)(_container2.default)(_templateObject3, _colors.Colors.PrimaryText, function (_ref2) {
    var hover = _ref2.hover;
    return hover && 'background: ' + (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.Lighter) + ';';
}, function (_ref3) {
    var active = _ref3.active;
    return active && 'background: ' + (0, _getColor2.default)(_colors.Colors.PrimaryText, _opacity2.default.VeryLight) + ';';
});

var VerticalDivider = (0, _styledComponents2.default)(_container2.default)(_templateObject4, (0, _getColor2.default)(_colors.Colors.Primary, _opacity2.default.Dark));

var MenuLabel = (0, _styledComponents2.default)(_label2.default)(_templateObject5, function (_ref4) {
    var hover = _ref4.hover;
    return hover && 'color: ' + _colors.Colors.Tertiary + ';';
});

var SideBar = function (_React$Component) {
    _inherits(SideBar, _React$Component);

    function SideBar(props) {
        _classCallCheck(this, SideBar);

        var _this = _possibleConstructorReturn(this, (SideBar.__proto__ || Object.getPrototypeOf(SideBar)).call(this, props));

        _this.state = {
            topLevelActiveTab: null,
            topLevelHoverTab: null
        };
        return _this;
    }

    _createClass(SideBar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ topLevelActiveTab: this.props.defaultTab });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(code) {
            this.setState({ topLevelActiveTab: code });
            this.props.clickEvent(code);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                SideTabWrapper,
                { desktop: this.context.screen.isDesktop, count: this.props.tabs.length },
                _react2.default.createElement(
                    SideTabInner,
                    { desktop: this.context.screen.isDesktop, count: this.props.tabs.length },
                    _react2.default.createElement(
                        _grid2.default,
                        null,
                        _react2.default.createElement(
                            _row2.default,
                            { nogutter: true },
                            this.props.tabs.map(function (tab, i) {
                                var hover = _this2.state.topLevelHoverTab === tab.code;
                                var active = _this2.state.topLevelActiveTab === tab.code;
                                return _react2.default.createElement(
                                    _column2.default,
                                    { xs: 6, md: 4, lg: 12, nogutter: true },
                                    _react2.default.createElement(
                                        MenuTab,
                                        {
                                            mouseEnterEvent: function mouseEnterEvent() {
                                                return _this2.setState({ topLevelHoverTab: tab.code });
                                            },
                                            mouseLeaveEvent: function mouseLeaveEvent() {
                                                return _this2.setState({ topLevelHoverTab: null });
                                            },
                                            clickEvent: function clickEvent() {
                                                return _this2.handleClick(tab.code);
                                            },
                                            verticalAlignment: _alignments.Alignments.center,
                                            desktop: _this2.context.screen.isDesktop,
                                            key: 'topLevelTab.' + tab.code,
                                            hover: hover,
                                            active: active,
                                            inline: true
                                        },
                                        active && _react2.default.createElement(VerticalDivider, null),
                                        _react2.default.createElement(
                                            _container2.default,
                                            { verticalAlignment: _this2.context.screen.isMobile ? _alignments.Alignments.center : _alignments.Alignments.bottom },
                                            _react2.default.createElement(MenuLabel, {
                                                hover: hover,
                                                bold: active,
                                                left: active ? _sizes.Sizes.xs : _sizes.Sizes.sm,
                                                textAlign: _alignments.Alignments.left,
                                                text: tab.label
                                            })
                                        )
                                    )
                                );
                            })
                        )
                    )
                )
            );
        }
    }]);

    return SideBar;
}(_react2.default.Component);

SideBar.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = SideBar;